<template>
  <modal
    name="drive-move"
    height="auto"
    width="500px"
    :scrollable="true"
    :adaptive="true"
    class="modal-dialog"
    @closed="$emit('close')"
  >
    <div class="modal-content o-common-modal-content">
      <div class="modal-header text-center">
        <button type="button" class="close" @click="closeModal">
          <i class="fa fa-times" aria-hidden="true"></i>
        </button>
        <h4 class="modal-title">Move "{{ file.name }}"</h4>
      </div>
      <div class="modal-body" v-loading="loading">
        <!-- Current path -->
        <div class="drive-move-path">
          <a
            v-for="(crumb, idx) in pathCrumbs"
            :key="crumb.id"
            href="javascript: void(0)"
            @click="navigateTo(crumb.id)"
            :class="{ 'drive-move-path-active': idx === pathCrumbs.length - 1 }"
          >
            <i v-if="idx === 0" class="fa fa-home" aria-hidden="true"></i>
            {{ crumb.name }}
            <span v-if="idx < pathCrumbs.length - 1"> / </span>
          </a>
        </div>

        <!-- Folder list -->
        <div class="drive-move-folders">
          <div
            v-for="folder in folders"
            :key="folder.id"
            class="drive-move-folder-item"
            :class="{ 'drive-move-folder-selected': selectedFolderId === folder.id }"
            @click="selectedFolderId = folder.id"
            @dblclick="navigateTo(folder.id)"
          >
            <i class="fa fa-folder" aria-hidden="true" style="color: #f0c040; margin-right: 8px;"></i>
            {{ folder.name }}
          </div>
          <div v-if="folders.length === 0 && !loading" style="padding: 20px; text-align: center; color: #999;">
            No subfolders
          </div>
        </div>
      </div>
      <div class="modal-footer text-center">
        <a
          href="javascript: void(0)"
          class="c-solid-btn c-solid-btn--green"
          @click="confirmMove"
        >
          <i class="fa fa-check" aria-hidden="true"></i> Move Here
        </a>
        <a
          href="javascript: void(0)"
          class="c-solid-btn"
          style="margin-left: 10px;"
          @click="closeModal"
        >
          Cancel
        </a>
      </div>
    </div>
  </modal>
</template>

<script>
export default {
  name: "DriveMoveDialog",
  props: {
    file: { type: Object, required: true },
    rootDriveId: { type: String, required: true },
  },
  data() {
    return {
      loading: false,
      folders: [],
      currentParentId: null,
      selectedFolderId: null,
      pathCrumbs: [{ id: null, name: "Home" }],
    };
  },
  mounted() {
    this.$modal.show("drive-move");
    this.loadFolders(null);
  },
  methods: {
    loadFolders: function (parentId) {
      this.loading = true;
      this.selectedFolderId = null;
      this.currentParentId = parentId;
      this.$emit("load-folders", {
        parentId: parentId,
        callback: this.onFoldersLoaded,
      });
    },
    onFoldersLoaded: function (folders) {
      this.loading = false;
      // Filter out the file being moved (if it's a folder)
      var self = this;
      this.folders = folders.filter(function (f) {
        return f.id !== self.file.id;
      });
    },
    navigateTo: function (folderId) {
      // Update breadcrumb path
      if (!folderId) {
        this.pathCrumbs = [{ id: null, name: "Home" }];
      } else {
        // Check if navigating back in crumbs
        var existingIdx = -1;
        for (var i = 0; i < this.pathCrumbs.length; i++) {
          if (this.pathCrumbs[i].id === folderId) {
            existingIdx = i;
            break;
          }
        }
        if (existingIdx >= 0) {
          this.pathCrumbs = this.pathCrumbs.slice(0, existingIdx + 1);
        } else {
          // Find selected folder name
          var folder = this.folders.find(function (f) { return f.id === folderId; });
          if (folder) {
            this.pathCrumbs.push({ id: folderId, name: folder.name });
          }
        }
      }
      this.loadFolders(folderId);
    },
    confirmMove: function () {
      var targetId = this.selectedFolderId || this.currentParentId || this.rootDriveId;
      this.$emit("confirm-move", { fileId: this.file.id, parentId: targetId });
      this.closeModal();
    },
    closeModal: function () {
      this.$modal.hide("drive-move");
      this.$emit("close");
    },
  },
};
</script>

<style scoped>
.drive-move-path {
  padding: 8px 0;
  margin-bottom: 10px;
  border-bottom: 1px solid #eee;
  font-size: 13px;
}
.drive-move-path a {
  color: #337ab7;
}
.drive-move-path-active {
  font-weight: 600;
}
.drive-move-folders {
  max-height: 300px;
  overflow-y: auto;
  border: 1px solid #eee;
  border-radius: 4px;
}
.drive-move-folder-item {
  padding: 10px 12px;
  cursor: pointer;
  border-bottom: 1px solid #f5f5f5;
}
.drive-move-folder-item:hover {
  background: #f5f7fa;
}
.drive-move-folder-selected {
  background: #e8f0fe;
}
</style>
